import type { MenuScreen } from '../types.js';
import { createScreenShell, createMenuHeader, createSettingsPanel } from '@bn-games/ui-shell';
import { buildSettingsRows } from '../settingsRows.js';
import { t } from '../../i18n/I18n.js';
import { backRow } from './backButton.js';

export function createSettingsScreen(): MenuScreen {
  let frame: HTMLElement | null = null;

  return {
    mount(root, ctx) {
      const shell = createScreenShell();
      frame = shell.frame;
      const panel = createSettingsPanel({
        getRows: () => buildSettingsRows({ ctx }),
        tabs: [
          { id: 'gameplay', label: t('settings.tabs.gameplay') },
          { id: 'interface', label: t('settings.tabs.interface') },
          { id: 'audio', label: t('settings.tabs.audio') },
        ],
      });
      shell.body.append(createMenuHeader({ title: t('settings.title') }), panel.element, backRow(ctx));
      root.appendChild(frame);
    },
    unmount() {
      frame?.remove();
      frame = null;
    },
  };
}
